import { debounce } from "lodash";
import { addVariantToCart, updateVariantQty } from "../helpers.js";
import {
  getOmnibusPriceFromAPI,
  hideOmnibuspriceContainer,
} from "../../scripts/vendor/omnibus";

const MIN_LOADING_TIME = 500;

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = async (tile) => {
  if (!tile) return;

  const omnibusContainer = tile.querySelector(".omnibusprice");
  if (omnibusContainer) {
    const brand = omnibusContainer.dataset.omnibus_brand;
    const variantID = omnibusContainer.dataset.omnibus_id;

    if (brand && variantID) {
      const price = await getOmnibusPriceFromAPI(brand, variantID);
      const productCompareAtPrice =
        parseInt(omnibusContainer.dataset.compare_at_price) / 100;
      if (!productCompareAtPrice) {
        hideOmnibuspriceContainer(omnibusContainer);
      } else {
        const omnibusValue = omnibusContainer.querySelector(
          ".omnibusprice-value"
        );

        omnibusValue.innerText = window.theme.Currency.formatMoney(
          price * 100,
          window.theme.moneyFormat
        );
        omnibusContainer.classList.remove("hidden");
      }
    }
  }

  const actionsWrapper = tile.querySelector(
    ".product-tile__actions[data-stock][data-cart-qty]"
  );
  const qtyWrappers = tile.querySelectorAll("[data-cart-qty-value]");
  const labelWrappersSingular = tile.querySelectorAll("[data-label-singular]");
  const labelWrappersPlural = tile.querySelectorAll("[data-label-plural]");
  const variantId = tile.querySelector("[name='id']");
  const form = tile.querySelector("form");
  const labelProductAdded = tile.querySelector("[data-product-text]").getAttribute('data-product-text').trim();
  if (!actionsWrapper || !variantId || !form) return;

  const stock = parseInt(actionsWrapper.dataset.stock);
  var inCart = parseInt(actionsWrapper.dataset.cartQty);
  const btnMinus = actionsWrapper.querySelector(
    ".product-tile__actions-button--minus"
  );
  const btnPlus = actionsWrapper.querySelector(
    ".product-tile__actions-button--plus"
  );
  const qtyValue = actionsWrapper.querySelector(".product-tile__actions-value");
  if (!btnMinus || !btnPlus || !qtyValue) return;
  const itemAdded = new CustomEvent(
    `QuickBuy:${actionsWrapper.dataset.productId}`
  );

  const cartUpdatedCallback = (data) => {
    const line_item = data.items.find(
      (item) => item.variant_id == variantId.value
    );
    if (line_item?.quantity > 0) {
      qtyWrappers.forEach(
        (qtyWrapper) => (qtyWrapper.innerText = line_item.quantity)
      );

      labelWrappersPlural.forEach(
        function (labelWrapperPlural) {
          if (line_item?.quantity > 1) {
            labelWrapperPlural.style.display = 'inline';
          } else {
            labelWrapperPlural.style.display = 'none';
          }
        }
      );

      labelWrappersSingular.forEach(
        function (labelWrapperSingular) {
          if (line_item?.quantity > 1) {
            labelWrapperSingular.style.display = 'none';
          } else {
            labelWrapperSingular.style.display = 'inline';
          }
        }
      );

      if (line_item.quantity > inCart) {
        document.dispatchEvent(itemAdded);
      }
    }

    if (line_item?.quantity > inCart) {
      const cartPopupEvent = new CustomEvent("CartPopup:show", {
        detail: {
          lineItem: line_item,
          productString: labelProductAdded
        },
      });
      window.dispatchEvent(cartPopupEvent);
    }

    const addToCartEvent = new CustomEvent("ProductTile:addedToCart");
    window.dispatchEvent(addToCartEvent);

    actionsWrapper.dataset.cartQty = line_item?.quantity ?? 0;
    inCart = line_item?.quantity ?? 0;
  };

  const cartErrorCallback = () => {
    qtyValue.value = inCart;
  };

  const updateCartQty = debounce(async (newValue) => {
    actionsWrapper.classList.add("loading");
    const currTime = new Date().getTime();
    if (inCart == 0) {
      await addVariantToCart(
        variantId.value,
        newValue,
        cartUpdatedCallback,
        cartErrorCallback
      );
    } else {
      await updateVariantQty(
        null,
        variantId.value,
        newValue,
        cartUpdatedCallback,
        cartErrorCallback
      );
    }
    const waitTime = new Date().getTime() - currTime;
    if (waitTime < MIN_LOADING_TIME)
      setTimeout(() => {
        actionsWrapper.classList.remove("loading");
      }, MIN_LOADING_TIME - waitTime);
    else actionsWrapper.classList.remove("loading");
  }, 500);

  const valueChange = (changeValue) => {
    const newValue = parseInt(qtyValue.value) + changeValue;
    if (newValue < 0 || newValue > stock) return;

    qtyValue.value = newValue;
    if (newValue >= stock) {
      btnPlus.setAttribute("disabled", "");
    } else {
      btnPlus.removeAttribute("disabled");
    }
    if (newValue <= 0) {
      btnMinus.setAttribute("disabled", "");
    } else {
      btnMinus.removeAttribute("disabled");
    }

    updateCartQty(newValue);
  };

  btnMinus.addEventListener("click", () => valueChange(-1));
  btnPlus.addEventListener("click", () => valueChange(1));
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".product-tile__container"),
    (tile) => {
      window.dAgency.initProductTile(tile);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".product-tile__container"),
      (tile) => {
        window.dAgency.initProductTile(tile);
      }
    );
  });
}
